// extracted by mini-css-extract-plugin
module.exports = {"root":"AccountDetailsModal_root__11Gyi"};